import * as formWizardConstants from './constants';
import 'element-closest-polyfill';

/**
 * Gets the step ID associated with an element
 *
 * @param {Element} element
 */
export default function getStepId(element) {
  const step = element && element.closest(formWizardConstants.selectors.step);
  if(step) { return step.dataset.id; }
}
